module.exports = __webpack_public_path__ + "static/img/certificate08.e7d74182.jpeg";